import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const EditDetailBtn = ({ icon, showText = false, ...others }) => {
  return (
    <Button
      color="default"
      variant="outlined"
      {...others}
      icon={!icon ? <EditOutlined /> : icon}
    >
      {showText && "Editar"}
    </Button>
  );
};
